/**
 * Service: financeApi
 */
angular.module('acme.common.service.financeApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('FinanceApiService', ['$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.reports.service = endpoint + '/report/transaction/files';
        return this;
      },

      reports: {

        service: '',

        list: function(props) {
          var q,
              qs;

          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['page', 'pageSize', 'sortField', 'sortDirection']
            }
          });
          q = qs.query;

          return $http({
            method: 'get',
            url: this.service + q
          });
        },

        download: function(name) {
          window.location = this.service + '/' + name;
        }

      }

    };

}]);